import React from 'react'
import SearchWeather from './components/Searchweather/SearchWeather';

const App =() => {
  return (
    <div>
      <SearchWeather/>
    </div>
  )
}

export default App;
